export function toTitleCase(value) {
    var words = value.split(' ');
    var titled = words.map(function (word) {
        return word.slice(0, 1).toUpperCase() + word.slice(1);
    });
    return titled.join(' ');
}
//# sourceMappingURL=to-title-case.js.map